// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a3ea006d","667":"9bdbda8b","977":"6fd14fec"}[chunkId] + ".chunk.js";
};